import React ,{ useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import BlurOnOutlinedIcon from "@mui/icons-material/BlurOnOutlined"; // Chaos
import TuneRoundedIcon from "@mui/icons-material/TuneRounded"; // Order
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded"; // Insight
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded"; // Innovation
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Arrow Icon
import { motion } from "framer-motion";
import Footer from "./Footer";

import DataObjectOutlinedIcon from "@mui/icons-material/DataObjectOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

const iconsData = [
  { icon: <BlurOnOutlinedIcon />, label: "CHAOS", color: "#FFD700" },
  { icon: <TuneRoundedIcon />, label: "ORDER", color: "#4CAF50" },
  { icon: <BarChartRoundedIcon />, label: "INSIGHT", color: "#00AEEF" },
  { icon: <AutoAwesomeRoundedIcon />, label: "INNOVATION", color: "#FF5722" },
];

const ServiceHome = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component loads
  },[]);

  const services = [
    {
      title: "Migrate",
      icon: <DataObjectOutlinedIcon sx={{ fontSize: 70, color: "#6a1b9a" }} />,
      description:
        "We help your organization move to cloud-optimized technologies that deliver price and performance.",
      listTitle: "Migrate from:",
      items: ["SAP BW / Hana", "Teradata", "Netezza", "Exadata", "Microsoft SQL Server"],
      color: "#6a1b9a",
    },
    {
      title: "Modernize",
      icon: <AutoAwesomeOutlinedIcon sx={{ fontSize: 70, color: "#1565c0" }} />,
      description:
        "We help you adopt new design patterns that enable critical capabilities to compete in an AI-driven world.",
      listTitle: "Modernize your:",
      items: [
        "Data Architecture",
        "Governance & Security",
        "Analytics",
        "Data Operations",
        "Applications",
      ],
      color: "#1565c0",
    },
    {
      title: "Monetize",
      icon: <MonetizationOnOutlinedIcon sx={{ fontSize: 70, color: "#2e7d32" }} />,
      description:
        "We help you connect your data investments to real strategic outcomes.",
      listTitle: "Monetize with:",
      items: [
        "Native & Connected Applications",
        "Replatforming",
        "Data Sharing",
        "Machine Learning",
        "Artificial Intelligence",
      ],
      color: "#2e7d32",
    },
  ];

  const containerStyle = {
    textAlign: "center",
    padding: "20px",
  
    fontFamily: "Arial, sans-serif",
    color: "white",
  };

  

  const optionsContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
    marginTop: "60px", // Increased margin
    marginBottom: "60px", // Increased margin
  };

  const cardStyle = (color) => ({
    position: "relative",
    backgroundColor: "#1E1E1E",
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    width: "300px", // Increased width
    padding: "20px",
    textAlign: "center",
    border: `2px solid ${color}`,
    marginTop: "40px", // Increased margin
    paddingTop: "50px", // Adjusted padding
    color: "white",
  });

  const arrowContainerStyle = (color) => ({
    position: "absolute",
    top: "-50px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "110px", // Increased width
    height: "110px", // Increased height
    backgroundColor: "#1E1E1E",
    borderRadius: "50%",
    border: `2px solid ${color}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  });

  const optionTitleStyle = (color) => ({
    fontSize: "42px", // Increased font size
    color,
  });

  const optionDescriptionStyle = {
    fontSize: "18px", // Increased font size
    color: "#D3D3D3",
    textAlign: "left",
    fontFamily: "Roboto",
    lineHeight: "1.8",
  };

  const listTitleStyle = {
    fontSize: "22px",
    fontWeight: "bold",
    color: "white",
    textAlign: "left",
    marginTop: "10px",
  };

  


  const listItemStyle = {
    fontSize: "18px",
    color: "#D3D3D3",
    textAlign: "left",
    fontFamily: "Roboto",
    lineHeight: "1.8",
    marginLeft: 0, // Move list items to the left
  };


  const ulStyle = {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    paddingLeft: 0,  // Ensure list items are aligned to the very left
  };

  const liStyle = {
    marginBottom: "5px",
    textAlign: "left", // Ensure list items are aligned to the left
  };

  const AnimatedBox = ({ service }) => (
    <motion.div
      whileHover={{ y: -10 }} // ✅ Adds jump effect on hover
      transition={{ type: "spring", stiffness: 300 }} // ✅ Smooth jump animation
      style={cardStyle(service.color)}
    >
      <div style={arrowContainerStyle(service.color)}>{service.icon}</div>
      <h2 style={optionTitleStyle(service.color)}>{service.title}</h2>
      <p style={optionDescriptionStyle}>{service.description}</p>
      {service.listTitle && service.items && (
        <div>
          <h3 style={listTitleStyle}>{service.listTitle}</h3>
          <ul style={ulStyle}>
            {service.items.map((item, itemIndex) => (
              <li key={itemIndex} style={liStyle}>
                <span style={listItemStyle}>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </motion.div>
  );

  return (
    
    <Box
  sx={{
    position: "relative",
    color: "white",
    textAlign: "center",
    py: 6,
    px: 2,
    minHeight: "400px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    margin: 0,
    padding: 0,
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url("/image/servicebg.jpg")`,
      backgroundAttachment: "fixed", // Optional: Creates a parallax effect
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      zIndex: -2, // Keeps the image behind everything
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.6)", // ✅ Dark overlay (adjust opacity as needed)
      zIndex: -1, // Keeps overlay behind the text but above the image
    },
  }}
>
<Box sx={{ textAlign: "center", mt: 16, px: 3 }}>
      {/* Introductory Text */}
      <Typography variant="h2" sx={{ fontWeight: "bold", color: "white", mb: 2 }}>
        Our Services
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: "18px",
          color: "white",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        With a relentless focus on “why,” we combine our services to discover, design, and build
        the most impactful outcomes for you. We don’t come with predetermined processes. Rather,
        we roll up our sleeves and craft practical, end-to-end solutions in partnership with your teams.
      </Typography>

      <Box sx={{ mt: 8 }} />
      {/* Title */}
      <Typography variant={isMobile ? "h5" : "h2"} sx={{ fontWeight: "bold", mb: 5 }}>
        Data Innovation Journeys Start with
      </Typography>
      <Typography variant={isMobile ? "h5" : "h2"} sx={{ fontWeight: "bold", color: "#00AEEF" }}>
      <span style={{ color: "#00D5FF" }}>Tech Informatic Solutions</span>
      </Typography>

      {/* ICONS & ARROWS SECTION (SINGLE ROW) */}
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        transition={{
          repeat: Infinity, // Keep restarting
          repeatDelay: 5, // Pause before restarting
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: isMobile ? 1.5 : 4,
          marginTop: "2rem",
          marginBottom: "4rem" // Increased Spacing After Section
        }}
      
      >
        {iconsData.map((item, index) => (
          <React.Fragment key={index}>
            {/* ICON WITH LOOPING ANIMATION */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: index * 0.8, // Appear one by one
                repeat: Infinity,
                repeatDelay: 6, // Wait after full reset
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                {/* Circle around the icon */}
                <Box
                  sx={{
                    width: isMobile ? 80 : 120,
                    height: isMobile ? 80 : 120,
                    border: "2px solid #00AEEF",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mx: "auto",
                    backgroundColor: "black", 
                  }}
                >
                  {React.cloneElement(item.icon, {
                    sx: { fontSize: isMobile ? 50 : 80, color: item.color },
                  })}
                </Box>
                <Typography variant="body2" sx={{ mt: 1, fontSize: isMobile ? "10px" : "14px" }}>
                  {item.label}
                </Typography>
              </Box>
            </motion.div>

            {/* ARROW ANIMATION (Only add arrows between icons) */}
            {index < iconsData.length - 1 && (
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.8 + 0.5, // Arrow appears after icon
                  repeat: Infinity,
                  repeatDelay: 6, // Reset delay
                }}
              >
                <ArrowForwardIcon
                  sx={{
                    fontSize: isMobile ? 25 : 40,
                    color: "#00D5FF",
                    mx: isMobile ? 0.5 : 1,
                  }}
                />
              </motion.div>
            )}
          </React.Fragment>
        ))}
      </motion.div>

      </Box>

      <div style={containerStyle}>
      
      <Box sx={{ textAlign: "center", mt: 8, px: 3 ,gap: "10px" , marginBottom: "4rem" ,marginTop:"2rem" }}>
      {/* Introductory Text */}
      <Typography variant="h2" sx={{ fontWeight: "bold", color: "white", mb: 2 }}>
      Explore our services
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: "18px",
          color: "white",
          maxWidth: "800px",
          margin: "0 auto",
          lineHeight: "1.6",
        }}
      >
        Every successful journey begins with a plan, and a good plan is informed by experience and insight.  <span style={{ color: "#00D5FF" }}>Tech Informatic Solution</span> wrapped our expertise and research into a framework called The Data Innovation Journey, enabling your organization to deliver pragmatic solutions to real world problems.

Our services are broad, deep, and infinitely customizable, so you get exactly what you’re looking for.
      </Typography>               </Box>

                 <div style={optionsContainerStyle}>
      {services.map((service, index) => (
        <AnimatedBox key={index} service={service} /> // ✅ Using the animated component
      ))}
    </div>
      </div>
      <Box
  sx={{
    width: "100vw", // Full viewport width
    backgroundColor: "black", // Black background
    color: "white", // Text color for footer content
    padding: "20px 0", // Padding for top and bottom
    margin: 0, // Remove any extra margins
    display: "flex",
    justifyContent: "center", // Center content inside
    alignItems: "center",
    textAlign:"left",
    position: "relative", // Ensure it stays in place
    
  }}
>
  <Footer />
</Box>



    
    </Box>
  );
};

export default ServiceHome;
